import { createSlice } from "@reduxjs/toolkit"

export const userOtpSlice = createSlice({
	name: "otp",
	initialState: {
		otpMessage: "",
		errors: [],
	},

	reducers: {
		getOtpMessage: (state, action) => {
			state.otpMessage = action.payload
		},
		getOtpMessageSuccess: (state, action) => {
			state.otpMessage = action.payload
		},
		getResendOtpMessage: (state, action) => {
			console.log(action.payload, "reducer")
			state.users = action.payload
		},
		// forget the previous verification so the OTP page doesn't act on an old success
		clearOtpState: (state) => {
			state.otpMessage = ""
			state.errors = []
		},
		getErrors: (state, action) => {
			state.errors = action.payload

			// console.log(action.payload, "reducer")
		},
	},
})

// Action creators are generated for each case reducer function
export const {getOtpMessage, getOtpMessageSuccess, getErrors, getResendOtpMessage, clearOtpState} = userOtpSlice.actions

export default userOtpSlice.reducer
